import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * get Users By Filter
   * @param param filter Object
   */
  getUsers(param: any): Observable<any> {
    const url = `${environment.authUrl}/user`;
    return this.http.post(url, param);
  }

  /**
   * get role options by userType
   * @param param userType
   */
  getRoleOptions(userType: string): Observable<any>{
    const url = `${environment.authUrl}/role/roleOption/${userType}`;
    return this.http.get(url);
  }

  /**
   * Get Facility Options for DropDown
   */
  getFacilityOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/facility`;
    return this.http.get(url);
  }

  /**
   * Get Forwarder Options for DropDown
   */
  getForwarderOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/forwarder`;
    return this.http.get(url);
  }

  /**
   * Get Tenant Options for DropDown
   */
  getTenantOptions(): Observable<any> {
    const url = `${environment.authUrl}/tenant`;
    return this.http.get(url);
  }

  /**
   * insert user scope
   * @param saveObj
   */
  insertUserScope(saveObj: any): Observable<any>{
    const url = `${environment.authUrl}/user/userRoleScope`;
    return this.http.post(url, saveObj);
  }

  /**
   * update user scope
   * @param saveObj
   */
  updateUserScope(saveObj: any): Observable<any>{
    const url = `${environment.authUrl}/user/userRoleScope`;
    return this.http.put(url, saveObj);
  }

  /**
   * get User Scope By UserId
   * @param userId
   */
  getUserScope(userId: string): Observable<any>{
    const url = `${environment.authUrl}/user/userRoleScope/${userId}`;
    return this.http.get(url);
  }

  /**
   * Get Customer Options for DropDown
   */
  async getCustomerOptions(): Promise<any> {
    const url = `${environment.logisticsApiUrl}/Customer/Options`;
    return this.http.get(url).toPromise();
  }

  /**
   * change password
   * @param changePassWordObj
   * @returns
   */
  changePassword(changePassWordObj: any): Observable<any>{
    const url = `${environment.authUrl}/user/changePassword`;
    return this.http.post(url, changePassWordObj);
  }
}
